import { render } from "./DigitalReportResponse.vue?vue&type=template&id=25b33129"
import script from "./DigitalReportResponse.vue?vue&type=script&lang=js"
export * from "./DigitalReportResponse.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src745183879/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__